import { identity } from 'lodash-es'
import { isPromise } from './bits'

import envRaw from './env-raw'
import debugFields from './debug-fields'

export default envRaw.useCallTracker ? callTracker : identity

function callTracker(action) {
  function callTracker_wrapper() {
    try {
      callTracker_wrapper.callCount++
      callTracker_wrapper.inProcess = true
      const res = action.apply(null, arguments)
      if (!isPromise(res)) {
        callTracker_wrapper.inProcess = false
        return res
      } else {
        const mem = callTracker_wrapper.callCount
        return res.finally(() => {
          if (mem === callTracker_wrapper.callCount) {
            callTracker_wrapper.inProcess = false
          }
        })
      }
    } catch (err) {
      callTracker_wrapper.inProcess = false
      throw err
    }
  }

  callTracker_wrapper.callCount = 0
  callTracker_wrapper.inProcess = false

  return debugFields(callTracker_wrapper, {
    _action: action
  })
}
